const root = document.querySelector('#MainContent');
function syncPresentation() {
 const selection = root?.querySelector('[data-cro-selection]');
 if (!selection) return;
 const input = root.querySelector('.product-details variant-picker input:checked');
 const text = String(input?.value || '').toLowerCase();
 const full = /frasco|entero|original|sellado/.test(text) || /entero/.test(selection.dataset.productType) || (!/combo/.test(selection.dataset.productType) && parseInt(text, 10) > 30);
 const copy = full ? selection.dataset.fullCopy : /combo/.test(selection.dataset.productType) ? selection.dataset.comboCopy : selection.dataset.decantCopy;
 const target = selection.querySelector('[data-cro-format-copy]');
 if (target && target.textContent !== copy) target.textContent = copy;
}
function enrichProfile() {
 const description = root?.querySelector('[data-cro-description]');
 const profile = root?.querySelector('[data-cro-profile]');
 if (!description || !profile || profile.dataset.enriched) return;
 profile.dataset.enriched = 'true';
 for (const p of description.querySelectorAll('p, li')) {
  const strong = p.querySelector('strong');
  if (!strong || !/^(?:nota(?:s)? de )?(salida|coraz[oó]n|fondo|notas principales|familia olfativa)\s*:/i.test(strong.textContent.trim())) continue;
  const card = document.createElement('div');
  card.className = 'ess-cro-profile-card';
  const label = document.createElement('span');
  label.textContent = strong.textContent.replace(':', '');
  const body = document.createElement('p');
  body.textContent = p.textContent.replace(strong.textContent, '').trim();
  card.append(label, body); profile.append(card);
 }
 if (!profile.children.length) profile.hidden = true;
}
async function loadRelated(section) {
 if (section.dataset.loaded) return;
 section.dataset.loaded = 'true';
 try {
  const url = new URL(section.dataset.recommendationsUrl, location.origin);
  url.searchParams.set('product_id', section.dataset.productId);
  url.searchParams.set('section_id', section.dataset.sectionId);
  url.searchParams.set('limit', '8');
  url.searchParams.set('intent', 'related');
  const response = await fetch(url);
  if (!response.ok) return;
  const document = new DOMParser().parseFromString(await response.text(), 'text/html');
  const content = document.querySelector('[data-cro-related]');
  if (content?.children.length && !section.matches(':focus-within, [data-cro-quick-interacted]')) section.replaceChildren(...content.childNodes);
 } catch { return; }
}
const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { loadRelated(entry.target); observer.unobserve(entry.target); } }), { rootMargin: '400px' });
root?.querySelectorAll('[data-cro-related]').forEach(section => observer.observe(section));
root?.addEventListener('change', syncPresentation);
new MutationObserver(() => syncPresentation()).observe(root, { childList: true, subtree: true });
syncPresentation(); enrichProfile();
document.addEventListener('shopify:section:load', () => { syncPresentation(); enrichProfile(); root?.querySelectorAll('[data-cro-related]').forEach(section => observer.observe(section)); });

function syncStickyOptions(anchor) {
 const picker = root.querySelector('.product-details variant-picker');
 const component = anchor?.querySelector('add-to-cart-component');
 if (!component) return false;
 const groups = Array.from(picker?.querySelectorAll('fieldset[data-fieldset-index], select.variant-option__select') || []).map(group =>
  Array.from(group.querySelectorAll('input[type="radio"][data-option-value-id], option[data-option-value-id]'))
 ).filter(options => options.length > 1);
 let panel = component.querySelector('.ess-cro-sticky-options');
 if (!groups.length) {
  panel?.remove();
  return false;
 }
 if (!panel) {
  panel = document.createElement('div');
  panel.className = 'ess-cro-sticky-options';
  component.prepend(panel);
 }
 const data = groups.map(options => options.map(option => [
  option.dataset.optionValueId,
  option.getAttribute('aria-label') || option.textContent.trim(),
  option.dataset.optionAvailable === 'false' || option.disabled,
  option.checked || option.selected
 ]));
 const signature = JSON.stringify(data);
 if (panel.dataset.signature !== signature) {
  panel.dataset.signature = signature;
  const selects = data.map((options, index) => {
   const select = document.createElement('select');
   select.setAttribute('aria-label', groups[index][0].dataset.optionName || 'Presentación');
   for (const [id, label, unavailable, selected] of options) {
    const option = new Option(label, id, false, !!selected);
    option.disabled = unavailable && groups.length === 1;
    select.add(option);
   }
   select.addEventListener('change', () => {
    const current = root.querySelector('.product-details variant-picker');
    const option = current?.querySelector('[data-option-value-id="' + CSS.escape(select.value) + '"]');
    if (option instanceof HTMLInputElement) option.click();
    if (option instanceof HTMLOptionElement) {
     option.selected = true;
     option.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
   });
   return select;
  });
  panel.replaceChildren(...selects);
 }
 return true;
}

let purchaseAnchor = null;
let purchaseVisible = false;
function syncStickyPurchase() {
 const button = root?.querySelector('.product-details .add-to-cart-button');
 const currentPrice = root?.querySelector('.product-details product-price [ref="priceContainer"] .price');
 const label = button?.querySelector('.add-to-cart-text');
 if (label) {
  let price = label.querySelector('.ess-cro-sticky-price');
  const amount = button.disabled ? '' : currentPrice?.textContent.trim() || '';
  if (amount && !price) {
   price = document.createElement('span');
   price.className = 'ess-cro-sticky-price';
   label.append(price);
  }
  if (price && price.textContent !== amount) price.textContent = amount;
 }
 const overlay = document.querySelector('dialog[open]') || document.querySelector('#rsi_form_wrapper')?.getClientRects().length;
 const hasOptions = syncStickyOptions(purchaseAnchor);
 const active = window.matchMedia('(max-width: 749px)').matches && !purchaseVisible && button && (!button.disabled || hasOptions) && !overlay;
 document.body.classList.toggle('ess-cro-sticky-purchase', !!active);
}
const purchaseObserver = new IntersectionObserver(entries => { purchaseVisible = entries[0]?.isIntersecting || false; syncStickyPurchase(); }, { threshold: 0.2 });
function bindPurchaseAnchor() {
 const anchor = root?.querySelector('.product-details .essentia-atc-default');
 if (anchor && anchor !== purchaseAnchor) {
  if (purchaseAnchor) purchaseObserver.unobserve(purchaseAnchor);
  purchaseAnchor = anchor; purchaseObserver.observe(anchor);
 }
 syncStickyPurchase();
}
new MutationObserver(bindPurchaseAnchor).observe(document.body, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['open','disabled'] });
window.matchMedia('(max-width: 749px)').addEventListener('change', syncStickyPurchase);
window.addEventListener('resize', syncStickyPurchase);
root?.addEventListener('change', syncStickyPurchase);
bindPurchaseAnchor();

root?.addEventListener('change', event => {
 const option = event.target;
 if (!(option instanceof HTMLInputElement) || !option.matches('[data-cro-quick-variant]:checked')) return;
 const form = option.form;
 if (!form) return;
 form.closest('[data-cro-related]')?.setAttribute('data-cro-quick-interacted', '');
 form.elements.namedItem('id').value = option.value;
 form.elements.namedItem('quantity').value = option.dataset.quantity;
 form.closest('product-form-component').dataset.quantityDefault = option.dataset.quantity;
 form.querySelector('[data-cro-quick-price]').textContent = option.dataset.price;
});
